







































































































import { defineComponent, PropType } from '@vue/composition-api';
import IssueSummary from '../fields/IssueSummary.vue';
import IssueStatus from '../fields/IssueStatus.vue';
import IssuePriority from '../fields/IssuePriority.vue';
import { Issue } from '../../dataType';
import { useLocale } from '../../hooks/useLocale';
import { useIssue } from '../../hooks/useIssue';
import { VxeTablePropTypes } from 'vxe-table';
import { isOverseasVersion } from 'common-module/src/util';
import { RowVO } from './types';

export default defineComponent({
  components: {
    IssueSummary,
    IssueStatus,
    IssuePriority
  },
  props: {
    list: {
      type: Array as PropType<Issue[]>,
      required: true
    },
    showStayDays: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const { t, tc } = useLocale();
    const { openIssue } = useIssue();

    const columnSpanMethod: VxeTablePropTypes.SpanMethod<RowVO> = ({ row }: { row: RowVO }) => {
      if (row.title) {
        return { rowspan: 1, colspan: 5 };
      }
    };
    const rowClassName: VxeTablePropTypes.RowClassName<RowVO> = ({ row }: { row: RowVO }) => {
      if (row.title) {
        return 'showRowTitle';
      }
      return '';
    };

    return {
      t,
      tc,
      toIssue(issue: Issue) {
        openIssue(issue);
      },
      columnSpanMethod,
      rowClassName,
      overseas: isOverseasVersion
    };
  }
});
